import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import {
  MotifPaginationSelect,
  MotifPaginationSelectItem,
  MotifTableHeaderRenderer
} from '@ey-xd/motif-react';
import MotifTable from '@ey-xd/motif-react/components/table';
import CustomHeader from './CustomHeader';
import './MarketReportMotifCSS.css';
import MarketReportNumber from './MarketReportNumber';
import { fetchAllReport } from '../../services/chat.service';
import { openLinkInSameTab, splitName } from '../../utils/commonUtils';
import LoadIndicator from '../common/loadIndicator/LoadIndicator';
import MarketReportsHome from '../customDropdown/MarketReportsHome';
import {
  downloadMultipleFiles,
  downloadMultipleFilesBlob,
  downloadReport,
  downloadReportBlob
} from '../openai/services/ChatService';
import MotifToast from '@ey-xd/motif-react/components/toast';
import { useDispatch, useSelector } from 'react-redux';
import { selectedRowsCount, setFileNameForDownload, setFiltersForAPI } from '../../store/actions/commonActions';
import OverflowTooltip from '../common/OverflowTooltip';
import MarketPreview from './MarketPreview';
import { IStore } from "../../store";

const MarketReportTable = (): JSX.Element => {
  const location = useLocation();
  const initialFilename = location.state?.filename || '';
  const tableRef = useRef<{ api?: { sizeColumnsToFit: () => void } } | null>(null);
  const [rowData, setRowData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [pageSize, setPageSize] = useState(15);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingForFilters, setIsLoadingForFilters] = useState(false);
  const [showDownloadInPorgress, setShowDownloadInProgress] = useState(false);
  const [fileName, setSelectedFileName] = useState('');
  const [textboxFilename, setTextboxFilename] = useState(initialFilename);
  const [selectedMultipleFileName, setSelectedMultipleFileName] = useState<string[]>([]);
  const [disableDownload, setDisableDownload] = useState(false);
  const [selectedRows, setSelectedRows] = useState<number>(0);
  const dispatch = useDispatch();
  const [pdfUrl, setPdfUrl] = useState<string | null>(null);
  const [checkedsector, setCheckedsector] = useState<[]>([]);
  const [checkedSubsector, setCheckedSubSector] = useState<[]>([]);
  const [checkedgeography, setCheckedgeography] = useState<[]>([]);
  const [checkedReportType, setCheckedReportType] = useState<[]>([]);
  const [selectedContentAge, setSelectedContentAge] = useState<string>('');
  const [selectedSourceRadio, setSelectedSourceRadio] = useState('TBRC');
  const [isMarketPreview, setIsMarketPreview] = useState(false);
  const [pdfFileName, setPdfFileName] = useState('');
  const [filters, setFilter] = useState<any>({ checkedsector: [], checkedSubsector: [], checkedReportType: [], checkedgeography: [], selectedContentAge: '' });
  const userData = useSelector((store: IStore) => store.userProfile?.userData);
  const displayName = userData?.displayName.split(' ')?.[0];
  const [gridAPI, setGridAPI] = useState<any>(null);
  
  useEffect(() => {
    if (gridAPI && initialFilename) {
      handleReportSearch(initialFilename);
    }
  }, [gridAPI, initialFilename]);
  
  const [numberRowsSelected, setNumberRowsSelected] = useState(0);
  const [filterAppiled, setFilterApplied] = useState(false);
  const [filteredTableDataLength, setFilteredTableDataLength] = useState(0);
  const [isIframeDownloadButtonDisable, setIframeDownloadButtonDisable] = useState(false);
  const [isAnyFilteredAppliedGeo, setIsAnyFilteredAppliedGeo] = useState(false);
  const [isAnyFilteredAppliedSector, setIsAnyFilteredAppliedSector] = useState(false);
  const [isAnyFilteredAppliedSubSector, setIsAnyFilteredAppliedSubSector] = useState(false);
  const [isAnyFilteredAppliedReport, setIsAnyFilteredAppliedReport] = useState(false);
  const [isAnyFilteredAppliedContentAge, setIsAnyFilteredAppliedContentAge] = useState('');
  const [applyButtonClicked, setApplyButtonClicked] = useState(0);

  useEffect(() => {
    let obj = { checkedsector: [], checkedSubsector: [], checkedReportType: [], checkedgeography: [], selectedContentAge: '' };
    
    if(checkedsector.length === 0 && checkedSubsector.length === 0 && checkedReportType.length === 0 && checkedgeography.length === 0 && selectedContentAge === '') {
      setIsAnyFilteredAppliedGeo(false);
      setIsAnyFilteredAppliedSector(false);
      setIsAnyFilteredAppliedSubSector(false);
      setIsAnyFilteredAppliedReport(false);
      setIsAnyFilteredAppliedContentAge('');
    }

    else if (selectedSourceRadio === 'TBRC') {
      obj.checkedsector = checkedsector;
      obj.checkedReportType = checkedReportType;
      obj.selectedContentAge = selectedContentAge;
      obj.checkedgeography = checkedgeography;
      obj.checkedSubsector = [];
    }
    else {
      obj.checkedsector = [];
      obj.checkedSubsector = [];
      obj.checkedReportType = [];
      obj.checkedgeography = [];
      obj.selectedContentAge = '';
    }

    let modifiedObj = { checkedsector: isAnyFilteredAppliedSector ? obj.checkedsector : [], checkedSubsector: isAnyFilteredAppliedSubSector ? obj.checkedSubsector : [], checkedReportType: isAnyFilteredAppliedReport ? obj.checkedReportType : [], checkedgeography: isAnyFilteredAppliedGeo ? obj.checkedgeography : [], selectedContentAge: isAnyFilteredAppliedContentAge ? obj.selectedContentAge : '' };
    setFilter(modifiedObj);
    fetchAllReportData(modifiedObj)
    dispatch(setFiltersForAPI(modifiedObj, selectedSourceRadio));
    return () => {
      obj.checkedsector = [];
      obj.checkedSubsector = [];
      obj.checkedReportType = [];
      obj.checkedgeography = [];
      obj.selectedContentAge = '';
      setFilter(obj);
    }
  }, [isAnyFilteredAppliedGeo, isAnyFilteredAppliedSector, isAnyFilteredAppliedSubSector, isAnyFilteredAppliedReport, isAnyFilteredAppliedContentAge, applyButtonClicked]);

  const updateFilteredState = (checkedArray: any, setFilteredState: any) => {
    setFilteredState(checkedArray.length > 0);

    return(checkedArray.length > 0);
  }

  const onClickSearchbutton = (flags: any) => {
      setApplyButtonClicked(applyButtonClicked + 1);
      let selecetedSetState = flags == "geography" ? setIsAnyFilteredAppliedGeo : flags == "sectors" ? setIsAnyFilteredAppliedSector : flags == "report" ? setIsAnyFilteredAppliedReport : flags == "subsector" ? setIsAnyFilteredAppliedSubSector : setIsAnyFilteredAppliedContentAge;
      let selectedState = flags == "geography" ? checkedgeography : flags == "sectors" ? checkedsector : flags == "report" ? checkedReportType : flags == "subsector" ? checkedSubsector : selectedContentAge;
      updateFilteredState(selectedState, selecetedSetState);
  };

  const fetchAllReportData = async (modifiedObj: any) => {
    setFilterApplied(false);
    setIsLoadingForFilters(true);
    await fetchAllReport(modifiedObj).then((response) => {
      if (response) {
        if (filteredTableDataLength !== response.length) {
          setFilterApplied(true);
        }
        setRowData(response);
        setOriginalData(response);
        setIsLoading(false);
        setIsLoadingForFilters(false);
        setNumberRowsSelected(response?.length);
      } else {
        setFilterApplied(false);
        setRowData([]);
        setOriginalData([]);
        setIsLoading(false);
        setNumberRowsSelected(0);
      }
    }).catch((error) => {
      setRowData([]);
      setFilterApplied(false);
      setOriginalData([]);
      console.error("Error fetching chat response:", error);
      setIsLoading(false);
      setNumberRowsSelected(0);
    });
    dispatch(setFileNameForDownload([]));
    setSelectedRows(0);
  };

  useEffect(() => {
    const fetchData = async () => {
      await fetchAllReport().then((response) => {
        if (response) {
          setFilterApplied(false);
          setFilteredTableDataLength(response.length);
          setRowData(response);
          setOriginalData(response);
          setIsLoading(false);
          setNumberRowsSelected(response?.length);
        } else {
          setFilteredTableDataLength(0);
          setRowData([]);
          setOriginalData([]);
          setIsLoading(false);
          setNumberRowsSelected(0);
        }
      }).catch((error) => {
        setRowData([]);
        setOriginalData([]);
        console.error("Error fetching chat response:", error);
        setIsLoading(false);
        setNumberRowsSelected(0);
      });
    };
    fetchData();
  }, [initialFilename]);

  
   const closeModal = () => {
    setPdfUrl('');
    setPdfFileName('');
    setIsMarketPreview(!isMarketPreview);
  };

  const onDownloadClick = async() => {
    setIframeDownloadButtonDisable(true);
    if (pdfFileName) {
      const reportBlob = await downloadReport(pdfFileName.toString());
      if (reportBlob) {
        setIframeDownloadButtonDisable(false);
        const blob = new Blob([reportBlob.pdf_data], { type: 'application/pdf' });
        const blobUrl = URL.createObjectURL(blob);
        downloadReportBlob(reportBlob, pdfFileName);
      }
    }
  }

  const onReportClick = async (params: any) => {
    setIsMarketPreview(!isMarketPreview);
    setPdfFileName(params);
    const reportBlob = await downloadReport(params);
    if (reportBlob) {
      const blobUrl = reportBlob.pdf_data;
      setPdfUrl(blobUrl);
    }
   };

  const getColumnDefs = (selectedDataSource: string, selectedRowCount: number) => {
    const commonColumns = [
      {
        field: "",
        checkboxSelection: true,
        flex: 0.3,
        handleCheckboxSelection: true,
      },
      {
        field: "isSelected",
        id: "isSelected",
        hide: true,
      },
      {
        field: "Source",
        headerName: "Data source",
        sortable: true,
        flex: 0.6,
        sort: "asc",
      },
      {
        field: "PdfFile",
        headerName: "Report name",
        flex: 1,
        sortable: true,
        sort: "asc",
        cellRenderer: (params: any) => {
          return(
          <OverflowTooltip tooltipContent={params.data.PdfFile}>
              <span onClick={() => onReportClick(params.data.PdfFile)}>{params.data.PdfFile}</span>
            </OverflowTooltip>
          )
        },
      }
    ];

    if (selectedDataSource === 'TBRC') {
      return [
        ...commonColumns,
        {
          field: 'Sector',
          headerName: 'Sector',
          flex: 0.6,
          sortable: true,
          sort: 'asc',
          cellRenderer: (params: any) => {
            return (
              <OverflowTooltip tooltipContent={params.data.Sector}>
                {params.data.Sector}
              </OverflowTooltip>
            );
          }
        },
        {
          field: 'reportType',
          headerName: 'Report type',
          flex: 0.6,
          sortable: true,
          sort: 'asc'
        },
        {
          field: 'Date',
          headerName: 'Date of publishing',
          flex: 0.6,
          sortable: true,
          sort: 'asc',
          comparator: (date1: any, date2: any) => {
            const parseDate = (dateString: string) => {
              const [day, month, year] = dateString.split('-');
              return new Date(`${year}-${month}-${day}`);
            };
            const d1 = parseDate(date1);
            const d2 = parseDate(date2);
            return d1.getTime() - d2.getTime();
          },
          cellRenderer: (params: any) => {
            const dateString = params.data.Date;
            const [day, month, year] = dateString.split('-');
            const date = new Date(`${year}-${month}-${day}`);
            const formattedMonth = String(date.getMonth() + 1).padStart(2, '0');
            const formattedDay = String(date.getDate()).padStart(2, '0');
            const formattedYear = date.getFullYear();
            return `${formattedMonth}/${formattedDay}/${formattedYear}`;
          },
        },
      ];
    } else {
      return [
        ...commonColumns,
        {
          field: "geography",
          headerName: "Geography",
          flex: 0.6,
          sortable: true,
          sort: "asc",
        },
        {
          field: "Sector",
          headerName: "Sector",
          flex: 0.6,
          sortable: true,
          sort: "asc",
          cellRenderer: (params: any) => {
            return (
              <OverflowTooltip tooltipContent={params.data.Sector}>
                {params.data.Sector}
              </OverflowTooltip>
            )
          },
        },
        {
          field: "subSector",
          headerName: "Sub sector",
          flex: 0.6,
          sortable: true,
          sort: "asc",
          cellRenderer: (params: any) => {
            return (
              <OverflowTooltip tooltipContent={params.data.subSector}>
                {params.data.PdfFile}
              </OverflowTooltip>
            )
          },
        },
        {
          field: "reportType",
          headerName: "Report type",
          flex: 0.6,
          sortable: true,
          sort: "asc",
        },
        {
          field: "Date",
          headerName: "Date of publishing",
          flex: 0.8,
          sortable: true,
          sort: "asc",
        },
      ]
    }
  };
  const [columnDefs, setColumnDefs] = useState(getColumnDefs(selectedSourceRadio, selectedMultipleFileName?.length));

  useEffect(() => {
    setColumnDefs(getColumnDefs(selectedSourceRadio, selectedMultipleFileName?.length));
    const filteredTableData = originalData.length > 0 && selectedSourceRadio === "All"
      ? originalData
      : originalData.length > 0 && originalData?.filter((row: any) => row.Source === selectedSourceRadio) || [];
    setRowData(filteredTableData);
  }, [selectedSourceRadio, originalData]);

  const onRowSelection = (event: any) => {
    const selectedRows = event.api.getSelectedRows();
    dispatch(selectedRowsCount(selectedRows.length));
    setSelectedRows(selectedRows?.length);
    // if (selectedRows.length > 10) {
    //   event.node.setSelected(false);
    // } else {
    if (selectedRows.length === 1) {
      const fileName = selectedRows[0].PdfFile;
      setSelectedFileName(fileName);
      dispatch(setFileNameForDownload([fileName]));
      setSelectedMultipleFileName([]);
    } else if (selectedRows.length > 1) {
      const fileNames = selectedRows.map((row: any) => row.PdfFile);
      setSelectedMultipleFileName(fileNames);
      dispatch(setFileNameForDownload(fileNames));
      setSelectedFileName('');
    } else {
      setSelectedMultipleFileName([]);
      setSelectedFileName('');
      dispatch(setFileNameForDownload([]));
    }
    // }
  };

  useEffect(() => {
    const handleResize = () => {
      if (tableRef.current && tableRef.current.api) {
        tableRef.current.api.sizeColumnsToFit();
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleReportSearch = (eventOrValue: React.ChangeEvent<HTMLInputElement> | string) => {
    // const value = event.target.value;
    const value = typeof eventOrValue === 'string' ? eventOrValue : eventOrValue.target.value;
    setTextboxFilename(value);
    if (gridAPI) {
      gridAPI.setQuickFilter(value);
      const displayedRows: any[] = [];
      gridAPI.forEachNodeAfterFilterAndSort((node: any) => {
        displayedRows.push(node.data);
      });
      setNumberRowsSelected(displayedRows?.length);
    }
  };

  const handleSectorProfileDownload = () => {
    const linkObject = {
      url: process.env.REACT_APP_GENERATE_APP_SECTORTREND_URL,
      name: 'Sector Trend'
    };
    openLinkInSameTab(linkObject, '');
  }

  const getFormattedFileNames = () => {
    return {
      file_names: selectedMultipleFileName
    };
  };

  const handledReportDownload = async () => {
    if (fileName) {
      setShowDownloadInProgress(true);
      setDisableDownload(true);
      const reportBlob = await downloadReport(fileName.toString());
      if (reportBlob) {
        setShowDownloadInProgress(false);
        setDisableDownload(false);
        downloadReportBlob(reportBlob, fileName);
      }
    } else if (selectedMultipleFileName.length > 0) {
      setShowDownloadInProgress(true);
      setDisableDownload(true);
      const formattedFileNames = getFormattedFileNames();
      const reportBlob = await downloadMultipleFiles(formattedFileNames);
      if (reportBlob) {
        setShowDownloadInProgress(false);
        setDisableDownload(false);
        downloadMultipleFilesBlob(reportBlob);
      }
    }
  }

  if (isLoading) {
    return (
      <div className="loader loading">
        <LoadIndicator />
      </div>
    );
  }

  const onGridReady = (params: any) => {
    setGridAPI(params.api);
  }

  const onSelectionChanged = (params: any) => {
    const selectedRows = params.api.getSelectedRows();
    params.api.forEachNode((node: any) => {
      node.setDataValue("isSelected", selectedRows.includes(node.data) ? 1 : 0);
    });
    setTimeout(() => {
      params.api.refreshClientSideRowModel("sort");
      params.columnApi.applyColumnState({
        state: [{ colId: 'isSelected', sort: 'desc' }],
        applyOrder: true,
      });
    }, 200);
  };

  return (
    <div>
      <StyleAppStoreComponent>
        <label className='welcome-text top-text'>Welcome, {displayName}</label>
        <div className='text top-text'>Let's view, download or query on Market Reports on different sectors</div>
      </StyleAppStoreComponent>
      <StyledMarketReportTable selectedSourceRadio={selectedSourceRadio}>
        <MarketReportsHome
          checkedsector={checkedsector}
          setCheckedsector={setCheckedsector}
          checkedSubsector={checkedSubsector}
          setCheckedSubSector={setCheckedSubSector}
          checkedgeography={checkedgeography}
          setCheckedgeography={setCheckedgeography}
          checkedReportType={checkedReportType}
          setCheckedReportType={setCheckedReportType}
          selectedContentAge={selectedContentAge}
          setSelectedContentAge={setSelectedContentAge}
          selectedSourceRadio={selectedSourceRadio}
          setSelectedSourceRadio={setSelectedSourceRadio}
          onClickSearchbutton = {onClickSearchbutton}
        />
        <MarketReportNumber rowData={originalData} selectedRows={selectedRows} selectedSourceRadio={selectedSourceRadio} filterAppiled = {filterAppiled} />
        {isLoadingForFilters && (
          <div className="overlay">
            <div className="loader loading">
              <LoadIndicator />
            </div>
          </div>
        )}

        <div className="custom-table">
          <CustomHeader
            handleReportSearch={handleReportSearch}
            handleSectorProfileDownload={handleSectorProfileDownload}
            handledReportDownload={handledReportDownload}
            rowData={rowData}
            showDownloadInPorgress={disableDownload}
            selectedRows={selectedRows}
            selectedSourceRadio={selectedSourceRadio}
            numberRowsSelected = {numberRowsSelected}
            filterAppiled = {filterAppiled}
            filename={textboxFilename}
          />
          {rowData?.length === 0 ?
            <NoDataContainer>No Report Found</NoDataContainer>
            :
            <MotifTable
              ref={tableRef}
              rowData={rowData}
              columnDefs={columnDefs}
              suppressCellFocus
              suppressRowClickSelection
              rowSelection="multiple"
              onRowSelected={(event: any) => onRowSelection(event)}
              pagination
              paginationPageSize={pageSize}
              onGridReady={onGridReady}
              suppressMovableColumns={true}
              onSelectionChanged={(event: any) => onSelectionChanged(event)}
              components={{
                agColumnHeader: MotifTableHeaderRenderer
              }}
              paginationSelect={
                <MotifPaginationSelect>
                  <MotifPaginationSelectItem
                    onClick={function noRefCheck() {
                      setPageSize(15);
                    }}  //@ts-ignore
                    selected
                  >
                    Show 15
                  </MotifPaginationSelectItem>
                  <MotifPaginationSelectItem
                    onClick={function noRefCheck() {
                      setPageSize(25);
                    }}
                  >
                    Show 25
                  </MotifPaginationSelectItem>
                  <MotifPaginationSelectItem
                    onClick={function noRefCheck() {
                      setPageSize(50);
                    }}
                  >
                    Show 50
                  </MotifPaginationSelectItem>
                </MotifPaginationSelect>
              }
            />
          }
        </div>
        {showDownloadInPorgress && (
          <MotifToast
            className="documents-ready"
            variant="success"
            actionName=""
            position="top"
            onClose={() => {
              setShowDownloadInProgress(false);
            }}
          >
            <div>
              Downloading..
            </div>
          </MotifToast>
        )}
        {isMarketPreview && (
          <MarketPreview show={isMarketPreview} closeModal={closeModal} pdfUrl={pdfUrl || ""} fileName={pdfFileName} onDownloadClick={onDownloadClick} isIframeDownloadButtonDisable = {isIframeDownloadButtonDisable} />
        )}
      </StyledMarketReportTable>
    </div>
  );
};

const StyledMarketReportTable = styled.div<{ selectedSourceRadio: string }>`
  background: #1A1A24;
  min-height: 90vh;

  .custom-table {
    margin-top: ${(props): string => props.selectedSourceRadio === 'All' ? '24px' : '50px'};
    margin-left: 24px;
    margin-bottom: 24px;
    width: 96%;
    border: 1px solid #3A3A4A;
    border-radius: 8px;
  }
  .ag-header-cell-text {
    color: #DEDEE2;
    font-size: 12px;
    font-weight: 400;
  }
  .motif-table {
    border: none;
  }
`;

const NoDataContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px;
  color: #dedee2;
  font-size: 18px;
`;

const StyleAppStoreComponent = styled.div`
  background: ##1A1A24;
  // min-height: 10vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 24px;
  margin-left: 12px;
  margin-bottom: 24px;
  width: 98%;

  .welcome-text {
    font-size: 28px;
    font-family: EYInterstate;
    font-weight: 400;
    line-height: 36px;
    color: #DEDEE2;
  }
  .text {
    font-size: 16px;
    font-family: EYInterstate;
    font-weight: 300;
    line-height: 24px;
    color: #A4A3B1;
    margin-top: 8px;
  }

  .top-text {
    width: 100%;
    position: relative;
    left: 1%;
  }
`;

export default MarketReportTable;